import { Product } from '../enums';

export enum PublishTrigger {
  // Publish once first publishing date has passed
  FIRST_PUBLISHING_DATE = 'first-publishing-date',

  // Publish once the product is confirmed (and verified if applicable e.g. obituaries)
  CONFIRMATION = 'confirmation'
}

export type ProductSiteSetting = {
  product: Product;

  // When to show an ad on the display site
  publishTrigger: PublishTrigger;

  // Subdomain of the site.  Must be globally unique.
  subdomainName: string;

  // Disables the display site from loading
  disabled: boolean;

  // Enables a custom GA token for publisher tracking and analytics
  gaToken?: string;
};

export type ProductSiteSettingUpdateRequest = {
  newspaperId: string;
  productSiteSetting: Partial<ProductSiteSetting>;
};

export type ProductSiteSettingCreateRequest = {
  newspaperId: string;
  productSiteSetting: ProductSiteSetting;
};

export type ProductSiteSettingCreateResponse = {
  productSiteSettingId: string;
};
